import { JobListResponse } from '@doda/api-client/aspida/@types';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { getJobListForTrendEmploymentStatus } from '@doda/common/src/services/getJobListForTrendAPI';

type JobSearchListEntityType = FetchBaseStateType<JobListResponse>;

/**
 * 初期型
 * @param jobRecommendListForTrend 取得求人一覧
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobRecommendListForTrendEmploymentStatusState {
  jobRecommendListForTrend: JobSearchListEntityType;
  initialDisplayFlag: number;
}

// 初期状態
export const jobRecommendListForTrendEmploymentStatusState: JobRecommendListForTrendEmploymentStatusState =
  {
    jobRecommendListForTrend: {
      loading: LOADING_STATUS.IDLE,
      entity: { results: [] },
    },
    initialDisplayFlag: -1,
  };

export const jobRecommendListForTrendEmploymentStatusSlice = createSlice({
  name: 'jobRecommendListForTrendEmploymentStatus',
  initialState: jobRecommendListForTrendEmploymentStatusState,
  reducers: {
    setInitialDisplayFlagEmploymentStatus: (state, action) => {
      state.initialDisplayFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getJobListForTrendEmploymentStatus.pending, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(
      getJobListForTrendEmploymentStatus.fulfilled,
      (state, action) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.SUCCESS;
        state.jobRecommendListForTrend.entity = action.payload;
      }
    );
    builder.addCase(getJobListForTrendEmploymentStatus.rejected, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.ERROR;
    });
  },
});

// Create Action
export const { setInitialDisplayFlagEmploymentStatus } =
  jobRecommendListForTrendEmploymentStatusSlice.actions;

// reducer
export const jobRecommendListForTrendEmploymentStatusReducer =
  jobRecommendListForTrendEmploymentStatusSlice.reducer;

interface State {
  jobRecommendListForTrendEmploymentStatus: JobRecommendListForTrendEmploymentStatusState;
}

/**
 * ローディングSelector
 * @param state
 * @returns 状態
 */
export const jobRecommendListForTrendEmploymentStatusLoadingSelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendEmploymentStatus?.jobRecommendListForTrend
    .loading;

/**
 * 求人一覧Selector
 * @param state
 * @returns 求人一覧
 */
export const jobRecommendListForTrendEmploymentStatusEntitySelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendEmploymentStatus?.jobRecommendListForTrend
    .entity;

/**
 * 初期表示判定フラグSelector
 * @param state
 * @returns 初期表示判定フラグ
 */
export const initialDisplayFlagEmploymentStatusSelector = <S extends State>(
  state: S
) => state.jobRecommendListForTrendEmploymentStatus.initialDisplayFlag;
